export default __webpack_public_path__ + "static/media/patient_caregiver.08ee6de4.jpeg";